<template>
  <div>
    <ld-header @click-left="back">
      {{ title }}
    </ld-header>

    <div v-if="cplx==10901||cplx==10902||cplx==10904">
      <div>
        <van-cell title="交通工具">
          <van-tag
            :class="[ cplx==10901 ? 'bg-main white' : 'main-color' ]"
            :plain="cplx==10904"
            size="large"
            @click="cplx=10901"
          >
            飞机
          </van-tag>&nbsp;
          <van-tag
            :class="[ cplx==10904 ? 'bg-main white' : 'main-color' ]"
            :plain="cplx==10901||cplx==10902"
            size="large"
            @click.native="cplx='10904'"
          >
            火车
          </van-tag>
        </van-cell>
        <van-field
          :label="$t('F006','出行人')"
          required
          @click="$refs.empList.toggle({cplx:cplx})"
          v-model="params.cxr"
          readonly
          :placeholder="$t('F006','出行人')"
        />
        <van-field
          :label="$t('K119','出差日期')"
          required
          @click="showDate"
          v-model="params.departDate"
          readonly
          :placeholder="$t('C106','出发日期')"
        />

        <van-row
          type="flex"
          align="center"
          class="bg-white"
          style="padding: 10px 16px;"
        >
          <van-col
            span="11"
            @click="toggle('city',1)"
          >
            <van-field
              v-model="params.depport.cityName"
              required
              readonly
              input-align="center"
              :placeholder="$t('C104','出发城市')"
              style="padding: 0;"
            />
          </van-col>
          <van-col
            span="2"
            @click="deparr"
            class="city-icon"
          >
            <ld-icon
              class="main-color"
              size="20"
              type="iconzhuanhuan"
            />
          </van-col>
          <van-col
            span="11"
            @click="toggle('city',2)"
          >
            <van-field
              v-model="params.arrport.cityName"
              required
              readonly
              input-align="center"
              :placeholder="$t('C105','到达城市')"
              style="padding: 0;"
            />
          </van-col>
        </van-row>

        <div class="bg-white overflow-auto">
          <div
            class="van-hairline--top van-hairline--bottom overflow-auto"
            style="margin: 0 16px; padding: 10px 0;"
          >
            <span class="formLabel-color fl font12">
              您可以提前查询一下
              <span v-show="cplx == 10901">航班</span>
              <span v-show="cplx == 10903">酒店</span>
              <span v-show="cplx == 10904">车次</span>
              价格，做好预算。
            </span>
            <van-tag
              plain 
              size="large"
              type="primary"
              @click="submit"
              class="fr"
              style="padding: 4px 18px;border-radius: 12px;"
            >
              {{ $t('B002','查询') }}
            </van-tag>
          </div>
        </div>

        <van-field
          clearable
          required
          v-model="params.fyys"
          type="number"
          maxlength="10"
          placeholder="请输入预算"
        >
          <template slot="label">
            {{ $t('E027','预算') }}<span class="font10">({{ $t('unit','单位') }}:￥)</span>
          </template>
        </van-field>
      </div>
    </div>

    <!-- 酒店 -->
    <div
      class="content"
      v-if="cplx==10903"
    >
      <van-field
        :label="$t('H056','入住人')"
        required
        readonly
        :placeholder="$t('H001','请选择入住人')"
        v-model="params.cxr"
        @click="openEmpList"
      />
      <van-field
        :label="$t('H003','入住城市')"
        required
        readonly
        v-model="params.depport.cityName"
        placeholder="请选择入住城市"
        @click="toggle('city',1)"
      />
      <div class="bg-white van-hairline--bottom">
        <van-row
          type="flex"
          align="center"
        >
          <van-col span="11">
            <van-field
              :label="$t('H066','入住')"
              required
              label-width="30"
              readonly
              v-model="params.departDate"
              :placeholder="$t('H006','入住时间')"
              @click="showDate"
            />
          </van-col>
          <van-col span="2">
            {{ params._days }}{{ $t('H008','晚') }}
          </van-col>
          <van-col span="11">
            <van-field
              :label="$t('H067','离店')"
              required
              readonly
              label-width="30"
              v-model="params.arriveDate"
              :placeholder="$t('H007','离店时间')"
              @click="showDate"
            />
          </van-col>
        </van-row>
      </div>
      <van-cell :title="$t('H034','房间数')">
        <van-stepper
          v-model="params.fjs"
          integer
          disable-input
        />
      </van-cell>
      <div class="bg-white overflow-auto">
        <div
          class="van-hairline--top van-hairline--bottom overflow-auto"
          style="margin: 0 16px; padding: 10px 0;"
        >
          <span class="formLabel-color fl font12">
            您可以提前查询一下酒店价格，做好预算。
          </span>
          <van-tag
            plain 
            size="large"
            type="primary"
            @click="submit"
            class="fr"
            style="padding: 4px 18px;border-radius: 12px;"
          >
            {{ $t('B002','查询') }}
          </van-tag>
        </div>
      </div>
      <van-field
        v-model="params.fyys"
        required
        type="number"
        maxlength="10"
      >
        <template slot="label">
          {{ $t('E027','预算') }}<span class="tr_orange tkcbin_font24">({{ $t('unit','单位') }}:￥)</span>
        </template>
      </van-field>
    </div>

    <!--  机票行程展示  -->
    <div
      class="pad-t-5"
      v-show="tk.route&&tk.route.length>0&&cplx==10901"
    >
      <van-cell>行程展示</van-cell>
      <route
        :route="tk.route"
        @delete="deletRoute"
      />
    </div>

    <!-- 国际机票 -->
    <div
      class="pad-t-5"
      v-show="tkIntflights&&tkIntflights.length>0&&cplx==10902"
    >
      <van-cell>行程展示</van-cell>
      <!-- <tk-int-voyage :flights="tkIntflights" /> -->
      <route
        :route="tkInt.route"
        @delete="deletRoute"
      />
    </div>
    <!-- 火车行程展示 -->
    <div
      class="pad-t-5"
      v-show="tr.route&&tr.route.length>0&&cplx==10904"
    >
      <van-cell>行程展示</van-cell>
      <route
        v-if="tr.route&&tr.route.length>0&&cplx==10904"
        :route="tr.route"
        @delete="deletRoute"
      />
    </div>
    <!-- 酒店行程展示 -->
    <div
      class="pad-t-5"
      v-show="ht.route&&ht.route.length>0&&cplx==10903"
    >
      <van-cell>行程展示</van-cell>
      <route
        :route="ht.route"
        @delete="deletRoute"
      />
    </div>
    
    <div class="query">
      <ld-button
        main
        size="lg"
        @click="confirm"
      >
        {{ $t('B006','确定') }}
      </ld-button>
    </div>

    <!-- 出差人 -->
    <ld-emp-list
      ref="empList"
      :person-list="personList"
      @selected="empChange"
    />
    <!-- 城市 -->
    <city
      ref="city"
      :sys-type="way"
      @selected="cityChange"
      :city-type="index"
      :cplx="cplx"
    />
    <!-- 日期 -->
    <!-- <ld-date 
      ref="date"
      :date="params.departDate"
      @selected="dateChange"
      :min-date="minDate"
      :max-date="maxDate"
    />
    <ld-date 
      ref="htDate"
      mode="1"
      @selected="dateChange"
      :start-date="params.departDate"
      :end-date="params.arriveDate"
      :min-date="minDate"
      :max-date="maxDate"
    /> -->
    <!-- 日期 -->
    <ld-calendar
      ref="date"
      :type="dateType"
      @selected="getDate"
      start-text="起"
      end-text="止"
    />
  </div>
</template>

<script>
import { Cell, Tag, Field, Stepper } from 'vant'
import ldEmpList from 'Components/ldEmpList/index.vue'
import City from 'Common/city'
import { formatDate,getDiffDays } from 'Utils/dateUtil'
import { mapGetters,mapActions } from 'vuex'
import ldButton from 'Common/ldButton'
import { getName, getEmpId } from 'Utils/publicFun'
import route from '../../components/route'

const obj= {
  '10901':'tk',
  '10902':'tkInt',
  '10903':'ht',
  '10904':'tr',
}
/*
* 新增及编辑草稿页面

*新增  清除各个产品查询预订缓存
*     如果从新增行程页面跳转过来 就获取新行程的缓存数据
*
*编辑  获取出差申请单详情  回显
*
*/ 
const PARAMS = () => {
  return {
    departDate:'',
    arriveDate:'',
    cxr:'',
    arrport:{},
    depport:{},
    fjs:1,//房间数
    fyys:0,//费用预算
    _days:1,//入住天数
  }
}
export default {
  name: 'ApplicationTravelPlan',
  components:{
    [Cell.name]:Cell,
    [Tag.name]:Tag,
    [Field.name]:Field,
    [Stepper.name]:Stepper,
    ldEmpList,
    City,
    ldButton,
    route,
    ldCalendar: () => import('Common/ldCalendar'),
  },
  data: function() {
    return {
      way:1,//1 出发 2到达
      params:PARAMS(),
      cplx:'',
      traverList:[],
      international:1,
      dateType:'',
    }
  },
  computed: {
    ...mapGetters({
      travelerList: 'trip/travelerList',
      tkSearchInfo: 'tk/tkSearchInfo',
      flightCache: 'tk/flightCache',
      tkIntSearchInfo: 'tkInt/tkIntSearchInfo',
      trSearchInfo: 'tr/trSearchInfo',
      htSearchInfo: 'ht/htSearchInfo',
      orderDetails: 'ht/orderDetails',
      tk: 'trip/tk',
      tkInt: 'trip/tkInt',
      ht: 'trip/ht',
      tr: 'trip/tr',
      addParams: 'trip/params',
      tripType: 'tripType',
      userInfo:'userInfo',
      pageCtrl: 'serviceCtrl', //页面控制信息
    }),
    title(){
      if(this.addParams.ccsqdNo){//编辑
        return '编辑行程'
      }
      return '新增行程'
    },
    index(){
      if(this.cplx==10901||this.cplx==10902){
        return 0
      }else if(this.cplx==10903){
        return 1
      }else if(this.cplx==10904){
        return 2
      }
      return 0
    },
    minDate(){
      return this.addParams.dateBegin
    },
    maxDate(){
      return this.addParams.dateEnd
    },
    tkIntflights(){//当前航班信息
      let ft=this.tkInt.route
      let f0=ft[0]
      let f1=ft[1]
      if(ft.length==0) return []
      if(ft.length>1){
        return [f0.qflightBean,f1.qflightBean]
      }else if(f0.hflightBean){
        return [f0.qflightBean,f0.hflightBean]
      }
      return [f0.qflightBean]
    },
    personList(){
      let person=this.addParams.vipPerson
      if(person&&person.length>0){
        person.forEach(item=>{
          item.checked=false
        })
        return person
      }
      return []
    }
  },
  beforeRouteLeave (to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if(to.name==='tripAdd'){
      this.$store.commit('tk/CLEAR_ALL',{})
      this.$store.commit('tkInt/CLEAR_ALL',{})
      this.$store.commit('ht/CLEAR_ALL',{})
      this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
    }
    next()
  },
  created () {
    this.init()
    this.getData()
  },
  methods: {
    init () {
      this.cplx=this.addParams.proType
      this.params=PARAMS()
      this.$store.commit('SET_SERVICE',{ cplx: this.cplx })
      this.params.ccrPerson=[this.userInfo.empInfo]
      this.params.ccr=getName(this.userInfo.empInfo)
      this.$store.commit('trip/travelerList', this.params.ccrPerson)


      this.empChange(this.travelerList)
      Object.assign(this.params,this[obj[this.cplx]].params)

      if(!this.params.departDate){
        this.params.departDate = formatDate(this.addParams.dateBegin).date
      }
      
      if (this.cplx==10903) {
        if (this.addParams.dateEnd) {
          this.params.arriveDate = formatDate(this.addParams.dateEnd).date
          this.params._days = getDiffDays(this.params.departDate, this.params.arriveDate)
          // var length=this.traverList.length
          // if(length%2==0){
          // 	this.params.fjs=parseInt(length/2)
          // }else{
          // 	this.params.fjs=parseInt(length/2)+1
          // }
        }
      }
    },
    getData(){
      if(this.cplx==10901&&this.tkSearchInfo.flights.length>0){
        this.$store.commit('tk/clearFlightCache')
        this.$store.commit('trip/tk',{params:this.params,route:this.tkSearchInfo.flights})
        this.$store.commit('tk/CLEAR_ALL',{})
      }else if(this.cplx==10902&&this.tkIntSearchInfo.flights.length>0){
        this.$store.commit('tkInt/CLEAR_ALL',{})
        this.$store.commit('trip/tkInt',{params:this.params,route:this.tkIntSearchInfo.flights})
      }else if(this.cplx==10903&&this.orderDetails._ratePlans){
        // this.$store.commit('ht/CLEAR_ALL',{})
        this.$store.commit('trip/ht',{params:this.params,route:[Object.assign(this.orderDetails,this.htSearchInfo)]})
      }else if(this.cplx==10904&&this.trSearchInfo.TrainDetail.trainCode){
        // this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
        this.$store.commit('trip/tr',{params:this.params,route:[{TrainDetail:this.trSearchInfo.TrainDetail,SeatDetail:this.trSearchInfo.SeatDetail}]})
      }
      Object.assign(this.params,this[obj[this.cplx]].params)
      this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
      this.$store.commit('ht/CLEAR_ALL',{})
    },
    toggle(name,way){
      this.way=way
      this.$refs[name].toggle()
    },
    openEmpList(){
      this.$refs.empList.toggle({cplx:this.cplx})
    },
    empChange(info){//出差人回调
      this.traverList=info
      let arr=[],arrid=[]
      this.traverList.forEach((v, k) => {
        if (v.empRank && (k == 0 || v.empRank < this.minzj)) {
          this.minzj = v.empRank
        }
        arr.push(getName(v))
        arrid.push(getEmpId(v))
      })
      this.params.cxr=arr.join(',')
      this.params.cxrId=arrid.join(',')
    },
    //城市回调
    cityChange(info){
      if (info.jcZdName) {
        info.threeCode = info.jcZdCode
        // info.cityName = info.jcZdName
      }
      if(info.zddm||info.zdmc){
        info.jcZdCode=info.zddm
        info.jcZdName=info.zdmc
      }
      if(this.way==1){
        this.params.depport=info//去程
      }else if(this.way==2){
        this.params.arrport=info//返程
      }
      if(this.params.depport.international==0||this.params.arrport.international==0){
        this.international=0
        if(this.cplx=='10901'){this.cplx='10902'}
      }else{
        this.international=1
        if(this.cplx=='10902'){this.cplx='10901'}
      }
    },
    showDate(){
      if(this.cplx==10903){
        this.dateType='range'
      }else{
        this.dateType='single'
      }
      this.$refs.date.toggle({
        defaultDate:this.cplx==10903?[this.params.departDate,this.params.arriveDate]:this.params.departDate,
        minDate:this.minDate,
        maxDate:this.maxDate,
      })
    },
    //日期 回调
    getDate (date) {
      if(Array.isArray(date)){
        [this.params.departDate,this.params.arriveDate]=date
        this.params._days=getDiffDays(date[0],date[1])
      }else{
        this.params.departDate=date
      }
    },
    deletRoute(index){//删除行程
      this[obj[this.cplx]].route.splice(index,1)
    },
    confirm(){//确定
      if(!this.params.cxr){
        this.$toast(this.$t('I001','请选择出行人'))
        return
      }
      if(!this.params.departDate){
        this.$toast(this.$t('F049','请选择')+this.$t('K119','出差日期'))
        return
      }
      if(!this.params.depport.cityName){
        this.$toast(this.$t('F049','请选择')+this.$t('C104','出发城市'))
        return
      }
      let arr=[]
      if(this.cplx=='10901'||this.cplx=='10902'||this.cplx=='10904'){
        if(!this.params.arrport.cityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C105','到达城市'))
          return
        }
        this.tk.route.forEach(item => arr.push(item))
        this.tkInt.route.forEach(item => arr.push(item))
        this.tr.route.forEach(item => arr.push(item))
        this.$store.commit('tk/CLEAR_ALL',{})
        this.$store.commit('tkInt/CLEAR_ALL',{})
        this.$store.commit('ht/CLEAR_ALL',{})
      }
      if(this.cplx=='10903'){
        if(!this.params.arriveDate){
          this.$toast('请选择离店时间')
          return
        }
        this.ht.route.forEach(item => arr.push(item))
        this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
      }
      if(arr.length==0&&this.params.cxr&&this.params.departDate){
        if(this.cplx==10901){
          this.$store.commit('tk/clearFlightCache')
          this.$store.commit('trip/tk',{params:this.params,route:[]})
          this.$store.commit('tk/CLEAR_ALL',{})
        }else if(this.cplx==10902){
          this.$store.commit('trip/tkInt',{params:this.params,route:[]})
          this.$store.commit('tkInt/CLEAR_ALL',{})
        }else if(this.cplx==10903){
          this.$store.commit('trip/ht',{params:this.params,route:[]})
          this.$store.commit('ht/CLEAR_ALL',{})
        }else if(this.cplx==10904){
          this.$store.commit('trip/tr',{params:this.params,route:[]})
          this.$store.commit('tr/CLEAR_TRSEARCHINFO',{})
        }
        this.confirm()
        return
      }
      this.addParams.vipRoute = [...this.addParams.vipRoute, ...arr]
      this.$store.commit('trip/CLEAR_ALL',{})
      this.$router.push({path:'/tripAdd'})
    },
    submit(){//查询
      if(!this.params.cxr){
        this.$toast(this.$t('I001','请选择出行人'))
        return
      }
      if(!this.params.depport.cityName){
        this.$toast(this.$t('F049','请选择')+this.$t('C104','出发城市'))
        return
      }
      this.addParams.proType=this.cplx
      if(this.cplx==10901){
        if(!this.params.arrport.cityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C105','到达城市'))
          return
        }
        this.tkQuery()
      }else if(this.cplx==10902){
        if(!this.params.arrport.cityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C105','到达城市'))
          return
        }
        this.tkIntQuery()
      }else if(this.cplx==10903){
        if(!this.params.arriveDate){
          this.$toast('请选择离店时间')
          return
        }
        this.htQuery()
      }else if(this.cplx==10904){
        if(!this.params.arrport.cityName){
          this.$toast(this.$t('F049','请选择')+this.$t('C105','到达城市'))
          return
        }
        this.trQuery()
      }
    },
    tkQuery(){//查询机票
      let tkSearchInfo={
        queryStr:{
          arriveAirport: this.params.arrport.jcZdCode||this.params.arrport.arriveAirport,
          departAirport: this.params.depport.jcZdCode||this.params.depport.departAirport,
          departDate: this.params.departDate,
          empRank: this.minzj,
          tripType: this.tripType,
          arriveDate: this.params.arriveDate,
        },
        departDate: formatDate(this.params.departDate),
        arriveDate: formatDate(this.params.arriveDate),
        // 国际
        // returnDate: this.arriveDate.date,
        // cabinType: this.cabin.cabin[0] || '',
        // aduNum: this.traverNum.traverNum[0], //  成人数量
        // chdNum: this.traverNum.traverNum[1], //  儿童数量
        // infNum: this.traverNum.traverNum[2], //  婴儿数量
        // travelType: this.roundtrip == 1 ? 2 : 1, //  是否往返程 2往返程 空或1单程 ,
        arrport:this.params.arrport,
        depport:this.params.depport,
        roundtrip:0,//单程
        path:'/tripRoute',
        backPath:'/tripRoute',
      }
      this.$store.commit('tk/clearFlightCache')
      this.$store.commit('tk/CLEAR_ALL',{})//
      Object.assign(this.tkSearchInfo,tkSearchInfo)//传入查询需要的参数
      this.$store.commit('tk/travelerList',this.traverList)//传入出行人 匹配差旅标准
      this.tk.params=this.params//缓存本次查询参数
      this.tk.traverList=this.traverList
      this.$router.push({path:'/tk/tkList'})
    },
    tkIntQuery(){//查询机票
      let tkIntSearchInfo={
        queryStr:{
          arriveAirport: this.params.arrport.jcZdCode||this.params.arrport.arriveAirport,
          departAirport: this.params.depport.jcZdCode||this.params.depport.departAirport,
          departDate: this.params.departDate,
          empRank: this.minzj,
          tripType: this.tripType,
          arriveDate: this.params.arriveDate,
          returnDate: this.params.arriveDate,
          cabinType: '',
          aduNum: 1, //  成人数量
          chdNum: 0, //  儿童数量
          infNum: 0, //  婴儿数量
          travelType: this.roundtrip == 1 ? 2 : 1, //  是否往返程 2往返程 空或1单程 ,
          'showStop': '',//是否经停 1显示0不显示 ,
          'airline': '',//航司二字代码 ,
          'requestId': '',//请求标记，第二次请求时回传，为第一次请求返回的值，避免重复查询数据库 ,
          'startCount': 0,//开始条数 ,
          'count': 20,//显示多少条数据
        },
        departDate: formatDate(this.params.departDate),
        arriveDate: formatDate(this.params.arriveDate),
        arrport:this.params.arrport,
        depport:this.params.depport,
        flights:[],
        roundtrip:0,//单程
        matchClbz: this.pageCtrl.isShowCxr, //是否匹配差旅标准
        path:'/tripRoute',
        backPath:'/tripRoute',
        showIntModel:true
      }
      this.$store.commit('tkInt/CLEAR_ALL',{})//
      Object.assign(this.tkIntSearchInfo,tkIntSearchInfo)//传入查询需要的参数
      this.$store.commit('tkInt/travelerList',this.traverList)//传入出行人 匹配差旅标准
      this.tkInt.params=this.params//缓存本次查询参数
      this.tkInt.traverList=this.traverList
      this.$router.push({path:'/tk/tkIntList'})
    },
    trQuery(){//查询火车票
      Object.assign(this.trSearchInfo, {
        fromStation: this.params.depport.cityName, //出发城市
        toStation: this.params.arrport.cityName, //到达城市
        fromStationCode: this.params.depport.jcZdCode, //出发城市三字码
        toStationCode: this.params.arrport.jcZdCode, //到达城市三字码
        byTrainDate: this.params.departDate, //出发日期
        path:'/tripRoute',
      })
      this.$store.commit('tr/travelerList',this.traverList)
      this.tr.params=this.params//缓存本次查询参数
      this.tr.traverList=this.traverList
      this.$router.push({path:'/tr/trList'})
    },
    htQuery(){//查询酒店
      this.$store.commit('ht/travelerList',this.traverList)
      Object.assign(this.htSearchInfo, {
        checkInDate: this.params.departDate, // 入住日期：yyyy-mm-dd
        checkOutDate: this.params.arriveDate, // 离店日期：yyyy-mm-dd
        _checkInDate: formatDate(this.params.departDate),
        _checkOutDate: formatDate(this.params.arriveDate),
        _city:this.params.depport.cityName,
        _cityId:this.params.depport.cityId,
        cityId: this.params.depport.cityId, // 城市id
        _days:this.params._days,
        path:'/tripRoute',
        backPath:'/tripRoute',
      })
      this.ht.params=this.params//缓存本次查询参数
      this.ht.traverList=this.traverList
      this.$router.push({path:'/ht/htQuery/htList'})
    },
    back(){
      this.$dialog.confirm({ title:this.$t('C474','提示'),message: '您确定退出该行程编辑' }).then(() => { 
        if(this.cplx==10901){
          this.$store.commit('trip/CLEAR_TK')
        }else if(this.cplx==10902){
          this.$store.commit('trip/CLEAR_TKINT')
        }else if(this.cplx==10903){
          this.$store.commit('trip/CLEAR_HT')
        }else if(this.cplx==10904){
          this.$store.commit('trip/CLEAR_TR')
        }
        this.$router.push({path:'/tripAdd'})
      })
    },
    //调换城市
    deparr() {
      let arrport=JSON.stringify(this.params.arrport)
      let depport=JSON.stringify(this.params.depport)
      this.params.depport=JSON.parse(arrport)
      this.params.arrport=JSON.parse(depport)
    },
  },
  watch:{
    cplx(val){
      this.addParams.proType=val
      this.init()
    }
  }
}
</script>
<style lang="less" scoped>
.pad-lr-8{
    padding-left:8px;
    padding-right: 8px; 
}
.pad-t-5{
    padding-top: 5px;
}
.pad-b-5{
    padding-bottom: 5px;
}
.city-icon {
    text-align: center;
    img{
        width: 34px;
        vertical-align: middle;
    }
}
.query{
    padding: 60px 16px 10px;
}
</style>